import axios from './axios';

const save = async () => {

    return axios.post(`device`).then(response => response.data).then(data => ({item: data}));
};

export {

    save,
}



// WEBPACK FOOTER //
// ./src/components/services/devices.js